/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useMemo, useContext } from 'react'
import {
  // unitIdHeader,
  modifierCol,
  modifiedDateCol,
} from 'core/HeaderColTypeProps'
import { dateCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  getMarginGasPrice,
  saveMarginGasPrice,
  deleteMarginGasPrice,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
  isValidYearRange,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import { Button, DatePicker, InputNumber, message } from 'antd'
import * as Actions from 'core/EventActions'

import CommonScreen from 'admin/component/CommonScreen'
// import { getPFuelCodeAtFuelUsageByClients } from 'marginanalysis/utils'

// import { toSelectionColProps } from '@integec/grid-tools'

import { DatePickerContext } from 'context'

const title = 'Gas Price'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

const GasPriceHeaders = [
  dateCol({
    ident: 'transdate',
    display: 'Transdate',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'price',
    display: 'Price',
    isFiltered: true,
    displayFormat: '0.0000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

// eslint-disable-next-line no-unused-vars
const GasPrice = ({ targetInfo, envConfig, actionPermits, ...props }) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)
  // const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [editMode, setEditMode] = useState(true)
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '120px 150px 80px 150px 100px 150px 150px 150px',
          gridGap: '5px',
        }}
      >
        <Label>Transdate :</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.transdateObj}
          onChange={date => {
            setInsertData({
              ...insertData,
              transdate: date.format('YYYY-MM-DD'),
              transdateObj: date,
            })
          }}
          style={{ width: '100%' }}
        />
        <Label>Price:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.price}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, price: value })}
        />
        <div />
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </CriteriaRow>
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])

  // eslint-disable-next-line no-unused-vars
  const withCriteria = (s, p, u, d) => {
    return {
      start: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      end: selectedDateRangePicker[1].format('YYYY-MM-DD'),
    }
  }

  // eslint-disable-next-line no-unused-vars
  const isEditableGrid = ({ header, rowData }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }
  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
          // retrieve({ dates: d })
        }}
      />
    )
  }
  // eslint-disable-next-line no-unused-vars
  const modifySaveDataBeforeSave = (saveData, validateData) => {
    const sv = saveData.find(p => !p.price || (p.price + '').length === 0)
    if (sv) {
      message.warning('Price is required field')
      return false
    }
    return saveData
  }
  const insertValidation = data => {
    if (!data.price) {
      message.warning('Price is required field')
      return false
    }
    return true
  }
  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }
  return (
    <CommonScreen
      beforeRetrieveValidation={beforeRetrieveValidation}
      insertValidation={insertValidation}
      modifySaveDataBeforeSave={modifySaveDataBeforeSave}
      screenCriteria={screenCriteria}
      withoutModify={!writeEventActionPermission}
      withDelete={!writeEventActionPermission}
      allowInsert={writeEventActionPermission}
      isEditableGrid={isEditableGrid}
      withDatePickerTitle=""
      autoRetrieve={false}
      isAdminScreen={false}
      withCriteria={withCriteria}
      title={title}
      header={GasPriceHeaders}
      saveTask={saveMarginGasPrice}
      retrieveTask={getMarginGasPrice}
      deleteTask={deleteMarginGasPrice}
      // altBy={u => u.unitId}
      sortOptions={GasPriceHeaders}
      initialSortOptions={GasPriceHeaders}
      totalWidth={800}
      insertComp={insertEvent && insertComp}
      insertCompHeight={60}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(GasPrice)
